import { render } from "./ChannelDataPage.vue?vue&type=template&id=7ffbaae7"
import script from "./ChannelDataPage.vue?vue&type=script&lang=js"
export * from "./ChannelDataPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__